export default ({ start, end }, context) => {
	return ({
		type: start.type,
		value: ({ start, end }),
	});
};